var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77138 16.2197C5.77138 15.1438 5.34041 14.1327 4.5553 13.3728L3.08197 11.9436L0 14.9348L2.63095 17.4868C3.32418 18.1593 3.70838 19.0537 3.71005 20.0032C3.70838 20.9495 3.32418 21.8423 2.63095 22.5148L0 25.0668L3.08364 28.0564L4.55697 26.6272C5.34041 25.8673 5.77305 24.8562 5.77305 23.7803V16.2181L5.77138 16.2197Z",
    fill: "#2E3BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 23.7835V16.2165C16.3636 15.1438 15.9326 14.1327 15.1475 13.3727L8.37884 6.80707L5.29688 9.79662L13.2231 17.4852C13.9164 18.1576 14.3006 19.0521 14.3022 20.0016C14.3006 20.9495 13.9164 21.8407 13.2231 22.5131L5.29688 30.2017L8.37884 33.1913L15.1475 26.6256C15.9326 25.8656 16.3636 24.8562 16.3636 23.7819",
    fill: "#2E3BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9915 20.0275V20.0211C27.9915 17.7445 27.9949 15.4646 27.9999 13.9642C28.0032 12.8478 27.5739 11.814 26.7922 11.0557L15.3964 0L11.1234 4.14486L23.6818 16.3267C24.6941 17.3086 25.2537 18.613 25.257 20C25.2537 21.3886 24.6941 22.693 23.6818 23.675L11.1234 35.8551L15.3964 40L26.7922 28.946C27.5756 28.1876 28.0049 27.1539 27.9999 26.0374C27.9949 24.5499 27.9915 22.2944 27.9915 20.034V20.0275Z",
    fill: "#2E3BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d4bfb123c35b10b7a0133d2223ef6f2f.svg";
export { ForwardRef as ReactComponent };